import api from '../../utils/api'

import { useEffect, useState } from 'react'

/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'
import FormSystemUser from './components/FormSystemUser'

function EditSystemUserPermission({ id, btCancelAction, handleOnSuccess }) {
    const [user, setUser] = useState({})
    const [myPermission, setMyPermission] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')

    const { setFlashMessage } = useFlashMessage()

    useEffect(() => {

        api.get(`/user/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {

            setMyPermission(response.data.permission)
            setUser(response.data.user)

        })

    }, [token, id])

    async function updateUser(user) {
        let msgType = 'success'


        const data = await api.patch(`user/edit/${user._id}`, user, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {

            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error') {

            handleOnSuccess()
        }

    }


    return (
        myPermission.group === "DEV_MASTER" || myPermission.group === "ADM_USER" ? (
            user.name && (
                <FormSystemUser handleSubmit={updateUser} btnText="Salvar" title="Permissões do Usuário" btCancelAction={btCancelAction} userPermission={user.permission} userData={user} permissionData={myPermission} mode="permission"/>
            )
        ) : (
            <div></div>
        )
    )
}

export default EditSystemUserPermission
